export const API_BASE = `https://go4digital.cc/wp/wp-json/siegfried/v1`;
export const GRAPHQL_BASE = `https://go4digital.cc/wp/graphql`;
export const FACEBOOK_PIXEL_ID = '';
export const GOOGLE_ANALYTICS_KEY = 'G-WMYC058HG3';
export const LINKEDIN_PIXEL_ID = '';
export const GOOGLE_TAG_MANAGER_KEY = 'GTM-MRB6RW7';

export const PRODUCTS_PER_PAGE = 12;